module.exports = __webpack_public_path__ + "static/img/nengli.b6f3fad.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/20250724/ruanjian/nengli.svg
// module id = wNPT
// module chunks = 41